import React, { Component } from "react";

import PropTypes from "prop-types";
import bioBackground from "../img/bio-background.png";
import bioThumb from "../img/bio-thumb.png";
//Images imports
import downArrow from "../img/icons/down-arrow.png";

class BioIndexComponent extends Component {
  render() {
    const { bio } = this.props;
    return (
      <section className="bio-index-section">
        <div className="bio-background-position">
          <img src={bioBackground} aria-hidden="true" />
        </div>
        <div className="container-fluid bio-background">
          <div className="container no-padding">
            <div className="d-none d-none-md d-lg-flex w-100 align-items-center justify-content-center arrow">
              <img src={downArrow} alt="" aria-hidden="true" />
            </div>
            <h1>{bio.title}</h1>
            <div className="row bio-chart offset-1 justify-content-center align-items-center">
              <div className="col-12 col-md-12 col-lg-7 bio-thumb d-flex align-items-center justify-content-center">
                <img src={bioThumb} alt={bio.title} />
              </div>
              <div className="col-12 col-md-12 col-lg-4">
                <div dangerouslySetInnerHTML={{ __html: bio.description }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

BioIndexComponent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default BioIndexComponent;



// WEBPACK FOOTER //
// ./src/components/bio-index.js